import React, {Component} from 'react';
import Breakpoints from '../utils/breakpoints'
import Radium from 'radium';
import marked from 'marked';
import Link from 'gatsby-link'
import Colors from '../utils/colors'
import {prettifyUrl, getLang} from '../utils/util-functions';

export class MenuTabs extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      linkString: props.path,
      activeLink: props.activeLink
    };
  }


  render() {


    return (
        <div style={styles.main}>
          <div className="col-xs-12">
            {this.props.items.map((item, i) =>
                {
                  let classes = this.props.items.length===3 ? "col-sm-4 col-xs-12" : "col-sm-6 col-xs-12";
                  if (this.props.activeMenu===prettifyUrl(item.type))
                    return (<div className={classes} key={i} style={[styles.item, styles.itemActive]} onClick={() => this.props.clickFunc(item.type)}>{item.name}</div>);
                  else
                    return (<div className={classes} key={i} style={styles.item} onClick={() => this.props.clickFunc(item.type)}>{item.name}</div>)
                }
            )}
          </div>
        </div>
    );
  }
}

export default Radium(MenuTabs);

const styles = {
  main: {

  },
  item: {
    display: 'inline-block',
    textAlign: 'center',
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: Colors.darkBlue,
    color: '#ffffff',
    borderLeft: 'solid #ffffff 1px',
    [Breakpoints.media.siteUnderPadWidth]: {
      borderLeft: 'none',
    },
    ':hover': {
      cursor: 'pointer'
    }
  },
  itemActive: {
    borderBottom: 'solid #ffffff 5px',
    paddingBottom: 15,
    opacity: 0.8,
    [Breakpoints.media.siteUnderPadWidth]: {
      borderBottom: 'none'
    }
  }
};


// WEBPACK FOOTER //
// ./src/components/MenuTabs.js